"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypeCountryDependentFee = void 0;
class PaymentTypeCountryDependentFee {
    constructor() { }
}
exports.PaymentTypeCountryDependentFee = PaymentTypeCountryDependentFee;
//# sourceMappingURL=payment.type.country.dependent.fee.nst.js.map